import { render, staticRenderFns } from "./IconMessageCircle.vue?vue&type=template&id=77c5b215"
import script from "./IconMessageCircle.vue?vue&type=script&lang=js"
export * from "./IconMessageCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports